__webpack_require__.p = "/metrics/";